module.exports = __webpack_public_path__ + "img/qr.13806f6c.svg";